// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2wDNY","bigColWidth":"Table_bigColWidth__K_xDd","biggerColWidth":"Table_biggerColWidth__18fzJ","row":"Table_row__1gewv","col":"Table_col__3DCE4"};